import React from "react";
import { connect } from "react-redux";

import {
  surveyTypesConstants,
  surveyStylePreviewConstants,
} from "../../../../views/shared-screens/constants";
import SurveyStylePreview from "./surveyStylePreview";

const { WIZARD, WIZARD_DESKTOP } = surveyTypesConstants;
const { NO_DISPLAY } = surveyStylePreviewConstants;

const WIZARD_LAYOUT = {
  rootClassName: "customize-emulator d-flex flex-column align-items-center",
  logoWrapClassName:
    "survey-theme-logo-wrap justify-content-center align-items-center d-flex",
  themeLogoFluid: false,
  customerInfoColClass: "col-8",
  customerInfoBorderClass: "py-2",
  footerRowClass: "mt-auto pb-3",
  buttonColClass: "col-12",
  buttonExtraClass: "",
  progressColClass: "col-12",
};

const WIZARD_DESKTOP_LAYOUT = {
  rootClassName:
    "customize-emulator d-flex flex-column align-items-center custom-macbook no-text-selection",
  logoWrapClassName: "survey-theme-logo-wrap ",
  themeLogoFluid: true,
  customerInfoColClass: "col-4",
  customerInfoBorderClass: "py-3",
  footerRowClass: "mt-auto pt-3",
  buttonColClass: "col-3",
  buttonExtraClass: "no-text-selection",
  progressColClass: "col-3",
};

const SurveyStyleTypes = (props) => {
  switch (props.displayType) {
    case WIZARD:
      return <SurveyStylePreview brand={props.brand} layout={WIZARD_LAYOUT} />;
    case WIZARD_DESKTOP:
      return (
        <SurveyStylePreview brand={props.brand} layout={WIZARD_DESKTOP_LAYOUT} />
      );
    default:
      return <div> {NO_DISPLAY} </div>;
  }
};

const mapStateToProps = (state) => ({
  brand: state.brandProfileReducer.brand,
});

export default connect(mapStateToProps, null)(SurveyStyleTypes);
